export default [
  {
    path: "/bantuan-sphp/",
    component: () => import("@/pages/bantuan-sphp/bantuan-sphp-list.vue"),
    meta: {
      title: "Daftar Bantuan SPHP",
      allowedProvinsiSublevels: [
        "produksi_perlindungan",
        "proteksi",
        "sarana_olah_hasil",
      ],
    },
  },
  {
    path: "/bantuan-sphp/create",
    component: () => import("@/pages/bantuan-sphp/bantuan-sphp-form.vue"),
    meta: {
      title: "Tambah Bantuan SPHP",
      allowedProvinsiSublevels: [
        "produksi_perlindungan",
        "proteksi",
        "sarana_olah_hasil",
      ],
    },
  },
  {
    path: "/bantuan-sphp/detail/:id",
    component: () => import("@/pages/bantuan-sphp/bantuan-sphp-detail.vue"),
    meta: {
      title: "Detail Bantuan SPHP",
      allowedProvinsiSublevels: [
        "produksi_perlindungan",
        "proteksi",
        "sarana_olah_hasil",
      ],
    },
  },
  {
    path: "/bantuan-sphp/update/:id",
    component: () => import("@/pages/bantuan-sphp/bantuan-sphp-update.vue"),
    meta: {
      title: "Update Bantuan SPHP",
      allowedProvinsiSublevels: [
        "produksi_perlindungan",
        "proteksi",
        "sarana_olah_hasil",
      ],
    },
  },
  {
    path: "/bantuan-sphp/import",
    component: () => import("@/pages/bantuan-sphp/bantuan-sphp-import.vue"),
    meta: {
      title: "Import Bantuan SPHP",
      allowedProvinsiSublevels: [
        "produksi_perlindungan",
        "proteksi",
        "sarana_olah_hasil",
      ],
    },
  },
];
